'use client';

import StatusBadge from '@alltrails/denali/components/StatusBadge';
import Typography from '@alltrails/core/components/Typography';
import { trackEvent } from '@alltrails/amplitude/utils/track';
import { type FooterLinksType } from '../../generateFooterLinks';
import styles from './styles.module.scss';

const DesktopLinks = ({ href, title, testId, amplitudeEventName, childLinks = [] }: FooterLinksType) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <a
        href={href}
        data-testid={testId}
        onClick={() => {
          if (amplitudeEventName) {
            trackEvent(amplitudeEventName);
          }
        }}
      >
        <Typography component="h2" variant="text300bold" mt="0" mb="0" color="inverse">
          {title}
        </Typography>
      </a>
    </div>
    <ul>
      {childLinks.map(link => (
        <li key={link.title} className={styles.childLink}>
          <a
            data-testid={link.testId}
            href={link.href}
            {...(link.openInNewWindow ? { target: '_blank' } : {})}
            onClick={() => {
              if (link.amplitudeEventName) {
                trackEvent(link.amplitudeEventName);
              }
            }}
          >
            {link.title}
          </a>
          {link.badge && <StatusBadge text={link.badge.text} variant={link.badge.variant} treatment={link.badge.treatment} size={link.badge.size} />}
        </li>
      ))}
    </ul>
  </div>
);

export default DesktopLinks;
